import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'terms_conditions_documents_unclearly_inaccurately_state'

export const dataPointDefinition = {
  retracedId: 'terms_conditions_documents_unclearly_inaccurately_state',
  name: 'Terms and conditions documents unclearly and/or inaccurately state the terms and conditions of employment',
  description:
    'The intent of this option selection is to understand if terms and conditions documents (for both local hires and foreign hires, if applicable) clearly state the terms and conditions of employment.',
  meta: {
    slcpMeta: {
      key: 'rh-emp-22x',
      number: 'RH-EMP-14-3',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'rh-emp-22x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 34500,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
